import styled from "styled-components";

import { colors } from "../shared/colors";
import { A } from "../shared/Typography";
// tests fail when importing directly from ../shared

export const StyledSocialLink = styled(A)`
    &:focus {
        outline: 3px solid ${colors.focus};
    }
`;
